import { render, staticRenderFns } from "./tixianManage.vue?vue&type=template&id=89c01d24&scoped=true&"
import script from "./tixianManage.vue?vue&type=script&lang=js&"
export * from "./tixianManage.vue?vue&type=script&lang=js&"
import style0 from "./tixianManage.vue?vue&type=style&index=0&id=89c01d24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89c01d24",
  null
  
)

export default component.exports